import React from 'react';
import classnames from 'classnames';
import s from './Sidebar.scss';
const Sidebar = ({ className, children })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, children);
Sidebar.displayName = 'Sidebar';
export default Sidebar;
